import React, { useEffect, useRef } from "react";
import { Card } from "@mui/material";
import AttendanceFilters from "./AttendanceFilters";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";

import NewAttendance from "./NewAttendance";

function AttendanceDashboard() {
  const fromDateRef = useRef(null);
  const endDateRef = useRef(null);

  return (
    <DashboardLayout>
      <Card
        sx={{
          maxHeight: "max-content",
          minHeight: "500px",
          paddingBottom: "30px",
        }}
      >
        <AttendanceFilters fromDateRef={fromDateRef} endDateRef={endDateRef} />
        <NewAttendance />
      </Card>
    </DashboardLayout>
  );
}

export default AttendanceDashboard;
